/**
 * Shared list pagination: page size options and the default used by ListTable
 * and TablePagination. Override `rowsPerPageOptions` only for special UIs
 * (fixed page size, infinite scroll, etc.).
 */
export const LIST_ROWS_PER_PAGE_OPTIONS: number[] = [10, 25, 50, 100];

export const LIST_DEFAULT_ROWS_PER_PAGE = 25;
